
function Output({ output, handleTarget, langs }) {


  

    return (

        <>
            <div>
            <select value={langs && langs[1]} onChange={handleTarget}>
                <option value="">Válassz nyelvet</option>
                <option value="en">Angol</option>
                <option value="zh">Kínai</option>
                <option value="es">Spanyol</option>
                <option value="ru">Orosz</option>
                <option value="fr">Francia</option>
                <option value="pt">Portugál</option>
                <option value="de">Német</option>
                <option value="it">Olasz</option>
                <option value="ja">Japán</option>
                <option value="nl">Holland</option>
                <option value="pl">Lengyel</option>
                <option value="uk">Ukrán</option>
                <option value="tr">Török</option>
                <option value="hr">Horvát</option>
                <option value="ro">Román</option>
                <option value="cs">Cseh</option>
                <option value="ko">Koreai</option>
                <option value="hu">Magyar</option>
                <option value="sk">Szlovák</option>
                <option value="el">Görög</option>
                <option value="sl">Szlovén</option>
                <option value="sv">Svéd</option>
                <option value="da">Dán</option>
                <option value="fi">Finn</option>
                <option value="th">Thai</option>
                <option value="no">Norvég</option>
                <option value="he">Héber</option>
                <option value="ar">Arab</option>
                <option value="bg">Bolgár</option>
                <option value="sq">Albán</option>
                <option value="vi">Vietnámi</option>
                <option value="la">Latin</option>
            </select>
            <textarea  value={output} placeholder="Fordítás" readOnly />
            </div>

        </>
    )
}

export default Output;